import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function News() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Toutes les actualités' },
    { id: 'events', name: 'Événements' },
    { id: 'partners', name: 'Partenaires' },
    { id: 'creators', name: 'Créateurs' },
    { id: 'practical', name: 'Infos Pratiques' }
  ];

  const articles = [
    {
      id: 1,
      category: 'events',
      title: 'Festival Afroverso 2026 : Les inscriptions sont ouvertes !',
      excerpt: 'Découvrez le programme complet du Festival Afroverso 2026 et réservez dès maintenant votre stand pour célébrer la créativité africaine.',
      date: '2024-01-15',
      author: 'Aminata Diallo',
      image: 'https://public.readdy.ai/ai/img_res/0a4135aa37507f83a0376c9cafdf345b.jpg',
      featured: true,
      tags: ['Festival', 'Afroverso', 'Inscriptions']
    },
    {
      id: 2,
      category: 'partners',
      title: 'Nouveau partenariat avec l\'Institut Français',
      excerpt: 'Ideevents s\'associe à l\'Institut Français pour promouvoir les échanges culturels franco-africains à travers des événements d\'exception.',
      date: '2024-01-10',
      author: 'Fatou Ndiaye',
      image: 'https://readdy.ai/api/search-image?query=Professional%20partnership%20announcement%20with%20French%20and%20African%20cultural%20symbols%2C%20handshake%2C%20institutional%20setting%2C%20diplomatic%20and%20cultural%20cooperation&width=600&height=400&seq=24&orientation=landscape',
      featured: false,
      tags: ['Partenariat', 'Institut Français', 'Coopération']
    },
    {
      id: 3,
      category: 'creators',
      title: 'Portrait : Kofi Mensah, créateur de mode éthique',
      excerpt: 'Rencontre avec Kofi Mensah, designer ghanéen qui révolutionne la mode africaine avec ses créations durables et innovantes.',
      date: '2024-01-08',
      author: 'Kofi Asante',
      image: 'https://readdy.ai/api/search-image?query=African%20fashion%20designer%20portrait%20in%20creative%20studio%20with%20colorful%20fabrics%2C%20sustainable%20fashion%20materials%2C%20artistic%20workspace%2C%20professional%20photography&width=600&height=400&seq=25&orientation=landscape',
      featured: false,
      tags: ['Portrait', 'Mode', 'Durabilité']
    },
    {
      id: 4,
      category: 'practical',
      title: 'Guide pratique : Comment participer au Pavillon Afrique',
      excerpt: 'Toutes les informations nécessaires pour exposer au Pavillon Afrique de la Foire Internationale de Nantes : démarches, tarifs, services.',
      date: '2024-01-05',
      author: 'Aminata Diallo',
      image: 'https://readdy.ai/api/search-image?query=Exhibition%20guide%20infographic%20with%20step-by-step%20process%2C%20African%20pavilion%20layout%2C%20practical%20information%20design%2C%20professional%20and%20informative%20style&width=600&height=400&seq=26&orientation=landscape',
      featured: false,
      tags: ['Guide', 'Pavillon Afrique', 'Exposition']
    },
    {
      id: 5,
      category: 'events',
      title: 'Retour sur le Pop-up Store Mode Africaine',
      excerpt: 'Découvrez les moments forts du dernier Pop-up Store dédié à la mode africaine qui s\'est tenu au cœur de Nantes.',
      date: '2024-01-03',
      author: 'Fatou Ndiaye',
      image: 'https://readdy.ai/api/search-image?query=African%20fashion%20pop-up%20store%20event%20recap%20with%20customers%20shopping%2C%20colorful%20clothing%20displays%2C%20successful%20retail%20event%20atmosphere&width=600&height=400&seq=27&orientation=landscape',
      featured: false,
      tags: ['Pop-up Store', 'Mode', 'Retour']
    },
    {
      id: 6,
      category: 'practical',
      title: 'Appel à projets : Ateliers Participatifs 2024',
      excerpt: 'Vous êtes artiste, artisan ou créateur ? Proposez votre atelier pour nos prochains événements culturels et partagez votre savoir-faire.',
      date: '2024-01-01',
      author: 'Kofi Asante',
      image: 'https://readdy.ai/api/search-image?query=Call%20for%20projects%20announcement%20with%20African%20cultural%20workshops%2C%20artisans%20working%2C%20creative%20collaboration%2C%20community%20engagement%20atmosphere&width=600&height=400&seq=28&orientation=landscape',
      featured: false,
      tags: ['Appel à projets', 'Ateliers', 'Créateurs']
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'Pavillon Afrique',
      date: '2026-04-02',
      location: 'Parc des Expositions, Nantes',
      status: 'Inscriptions ouvertes',
      endDate: '2026-04-06'
    },
    {
      id: 2,
      title: 'Afrovidedressing',
      date: '2026-05-01',
      location: 'Centre Culturel Nantes',
      status: 'Bientôt disponible'
    },
    {
      id: 3,
      title: 'Festival Afroverso',
      date: '2026-07-01',
      location: 'Parc des Expositions, Nantes',
      status: 'Save the date'
    }
  ];

  const filteredArticles = selectedCategory === 'all' 
    ? articles 
    : articles.filter(article => article.category === selectedCategory);

  const featuredArticle = articles.find(article => article.featured);
  const regularArticles = filteredArticles.filter(article => !article.featured);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-8">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-orange-500 to-teal-600 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Actualités & Blog</h1>
            <p className="text-xl max-w-3xl mx-auto">
              Restez informés de nos derniers événements, découvrez nos partenaires 
              et suivez l'actualité de la culture africaine à Nantes.
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="bg-white border-b border-gray-200 sticky top-24 z-40">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    selectedCategory === category.id
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-orange-100'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            
            {/* Main Content */}
            <div className="lg:col-span-2">
              
              {/* Featured Article */}
              {featuredArticle && selectedCategory === 'all' && (
                <article className="bg-white rounded-lg shadow-lg overflow-hidden mb-12">
                  <div className="relative">
                    <img
                      src={featuredArticle.image}
                      alt={featuredArticle.title}
                      className="w-full h-64 md:h-80 object-cover object-top"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                        À la une
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                      <span>{new Date(featuredArticle.date).toLocaleDateString('fr-FR')}</span>
                      <span className="mx-2">•</span>
                      <span>Par {featuredArticle.author}</span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                      {featuredArticle.title}
                    </h2>
                    <p className="text-gray-600 mb-6 text-lg">
                      {featuredArticle.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <div className="flex flex-wrap gap-2">
                        {featuredArticle.tags.map((tag) => (
                          <span key={tag} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-sm">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <button className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
                        Lire la suite
                      </button>
                    </div>
                  </div>
                </article>
              )}

              {/* Articles Grid */}
              <div className="space-y-8">
                <h2 className="text-2xl font-bold text-gray-900">
                  {selectedCategory === 'all' ? 'Derniers articles' : categories.find(c => c.id === selectedCategory)?.name}
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {regularArticles.map((article) => (
                    <article key={article.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-48 object-cover object-top"
                      />
                      <div className="p-6">
                        <div className="flex items-center text-sm text-gray-500 mb-3">
                          <span>{new Date(article.date).toLocaleDateString('fr-FR')}</span>
                          <span className="mx-2">•</span>
                          <span>Par {article.author}</span>
                        </div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
                          {article.title}
                        </h3>
                        <p className="text-gray-600 mb-4 line-clamp-3">
                          {article.excerpt}
                        </p>
                        <div className="flex items-center justify-between">
                          <div className="flex flex-wrap gap-1">
                            {article.tags.slice(0, 2).map((tag) => (
                              <span key={tag} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
                                {tag}
                              </span>
                            ))}
                          </div>
                          <button className="text-orange-500 hover:text-orange-600 font-medium text-sm cursor-pointer">
                            Lire →
                          </button>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="space-y-8">
              
              {/* Upcoming Events */}
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-6 flex items-center">
                  <i className="ri-calendar-line mr-2 text-orange-500"></i>
                  Prochains événements
                </h3>
                <div className="space-y-4">
                  {upcomingEvents.map((event) => (
                    <div key={event.id} className="border-l-4 border-orange-500 pl-4">
                      <h4 className="font-medium text-gray-900 mb-1">{event.title}</h4>
                      <p className="text-sm text-gray-600 mb-1">
                        <i className="ri-calendar-line mr-1"></i>
                        {event.endDate 
                          ? `${new Date(event.date).toLocaleDateString('fr-FR')} au ${new Date(event.endDate).toLocaleDateString('fr-FR')}`
                          : new Date(event.date).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
                        }
                      </p>
                      <p className="text-sm text-gray-600 mb-2">
                        <i className="ri-map-pin-line mr-1"></i>
                        {event.location}
                      </p>
                      <span className="inline-block bg-teal-100 text-teal-800 text-xs px-2 py-1 rounded-full">
                        {event.status}
                      </span>
                    </div>
                  ))}
                </div>
                <button className="w-full mt-6 bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
                  Voir tous les événements
                </button>
              </div>

              {/* Newsletter */}
              <div className="bg-gradient-to-r from-orange-500 to-teal-600 rounded-lg p-6 text-white">
                <h3 className="text-xl font-semibold mb-4">Newsletter</h3>
                <p className="text-orange-100 mb-6">
                  Recevez nos dernières actualités et ne manquez aucun événement !
                </p>
                <div className="space-y-3">
                  <input
                    type="email"
                    placeholder="Votre adresse email"
                    className="w-full px-4 py-2 rounded-lg text-gray-900 placeholder-gray-500"
                  />
                  <button className="w-full bg-white text-orange-500 py-2 rounded-lg hover:bg-gray-100 transition-colors font-medium whitespace-nowrap cursor-pointer">
                    S'abonner
                  </button>
                </div>
              </div>

              {/* Popular Tags */}
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-6">Tags populaires</h3>
                <div className="flex flex-wrap gap-2">
                  {['Festival', 'Afroverso', 'Mode', 'Artisanat', 'Cuisine', 'Musique', 'Pavillon Afrique', 'Partenariat', 'Créateurs', 'Ateliers'].map((tag) => (
                    <button
                      key={tag}
                      className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm hover:bg-orange-100 hover:text-orange-700 transition-colors cursor-pointer"
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-6">Suivez-nous</h3>
                <div className="space-y-3">
                  <a href="#" className="flex items-center p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                    <i className="ri-facebook-fill text-blue-600 text-xl mr-3"></i>
                    <span className="text-gray-700">Facebook</span>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-pink-50 rounded-lg hover:bg-pink-100 transition-colors">
                    <i className="ri-instagram-line text-pink-600 text-xl mr-3"></i>
                    <span className="text-gray-700">Instagram</span>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                    <i className="ri-tiktok-line text-gray-900 text-xl mr-3"></i>
                    <span className="text-gray-700">TikTok</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
